import Vue from 'vue'
import App from './App.vue'
import Meta from 'vue-meta'
import TextHighlight from 'vue-text-highlight';

Vue.component('text-highlight', TextHighlight);
import './assets/sass/styles.scss'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'
import router from './router'

Vue.use(Meta)

Vue.config.productionTip = false

const root = new Vue({
  render: h => h(App),
  router
}).$mount('#app')

document.addEventListener('DOMContentLoaded', function () {
  root.$mount('#app')
  document.dispatchEvent(new Event('vue-post-render'))
})
